<template>
  <Switch
    :label="t('common.payment.requireCreditCard')"
    :tooltip="true"
    :tooltip-message="t('common.payment.requireCreditCardTooltip')"
    :value="requireCreditCard"
    @update:value="onRequireCreditCardChange"
  ></Switch>
</template>

<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import Switch from "../Elements/Switch.vue";

/**
 * Field-level payment settings this component reads from and writes to.
 * `requireCreditCard` is absent on payment fields created before this setting
 * existed — those are treated as enabled.
 */
interface PaymentFieldSettings {
  requireCreditCard?: boolean;
}

const { t } = useI18n();
const store = useAppStore();

const props = defineProps({
  selectedIndex: {
    type: Number,
    required: true,
  },
  selectedSlideIndex: {
    type: Number,
    required: false,
    default: undefined,
  },
});

const paymentField = computed<PaymentFieldSettings | undefined>(() =>
  props.selectedSlideIndex !== undefined
    ? store.slides[props.selectedSlideIndex]?.slideData?.[props.selectedIndex]
    : store.elements[props.selectedIndex]
);

const requireCreditCard = computed(() => paymentField.value?.requireCreditCard ?? true);

const onRequireCreditCardChange = (value: boolean) => {
  if (!paymentField.value) return;
  paymentField.value.requireCreditCard = value;
  store.anyUnsavedChanges = true;
};
</script>
